import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button } from "antd";
import FullScreenModal from "components/utils/fullScreenModal";

function FastMessages({ onPress }) {
  const [isOpen, open] = useState(false);
  const messages = [
    "Hello my Dear",
    "Give me a few seconds to connect with your energy",
    "Yes i feel you!",
    "What question are you asking today?",
    "What worries you the most?",
    "Glad to see you here today!",
    "Let’s check dear",
    "Let me pull a card",
    "Let’s take a look at what the cards tell us",
    "I understand my dear",
    "I see something interesting",
    "Dear, I feel difficulties between you",
  ];

  return (
    <>
      <FullScreenModal
        open={isOpen}
        onCancel={() => open(false)}
        title="Fast Messages"
      >
        {messages.map((message, index) => {
          return (
            <Button
              key={`fast-message-${index}`}
              className="mt-10 mr-10"
              type="primary"
              ghost
              onClick={() => onPress(message)}
            >
              {message}
            </Button>
          );
        })}
      </FullScreenModal>
      <Button type="primary" ghost onClick={() => open(true)}>
        Fast messages
      </Button>
    </>
  );
}

FastMessages.propTypes = {
  onPress: PropTypes.func.isRequired,
};

export default FastMessages;
